import { render, staticRenderFns } from "./SurfaceList.vue?vue&type=template&id=228d2dc4&scoped=true"
import script from "./SurfaceList.vue?vue&type=script&lang=js"
export * from "./SurfaceList.vue?vue&type=script&lang=js"
import style0 from "./SurfaceList.vue?vue&type=style&index=0&id=228d2dc4&prod&lang=scss"
import style1 from "./SurfaceList.vue?vue&type=style&index=1&id=228d2dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d2dc4",
  null
  
)

export default component.exports